export function isJointApplicant() {
  const queryParams = new URLSearchParams(window.location.search);
  return queryParams.get('joint') === 'true';
}

export function getTrackingId() {
  const queryParams = new URLSearchParams(window.location.search);
  return queryParams.get('trackingId') ?? '';
}

export function maskEmail(email: string) {
  if (!email) return '';
  const [localPart, domain] = email.split('@');
  const maskedLocalPart = localPart.length > 4 ? localPart.slice(0, 4) + '*'.repeat(localPart.length - 4) : localPart;
  return `${maskedLocalPart}@${domain}`;
}

export function maskMobile(mobile: string) {
  if (!mobile) return '';
  return mobile.substring(0, 2) + mobile.substring(2, 6).replace(/[0-9]/g, '*') + mobile.substring(6, mobile.length);
}

export function parseAustralianPhoneNumber(phoneNumber?: string, shouldMask: boolean = true): string {
  if (!phoneNumber) return '';

  // Check if already masked (contains asterisks)
  if (phoneNumber.includes('*')) {
    return phoneNumber;
  }

  // Remove any spaces, dashes, or other non-digit characters except +
  let cleaned = phoneNumber.replace(/[^\d+]/g, '');

  // If it starts with +61, replace with 0
  if (cleaned.startsWith('+61')) {
    cleaned = '0' + cleaned.substring(3);
  }
  // If it doesn't start with 0 and looks like a valid AU mobile (8-10 digits), add 0 prefix
  else if (!cleaned.startsWith('0') && /^[1-9]\d{7,9}$/.test(cleaned)) {
    cleaned = '0' + cleaned;
  }
  return shouldMask ? maskMobile(cleaned) : cleaned;
}

export const isValidAustralianMobile = (phoneNumber?: string): boolean => {
  if (!phoneNumber) return false;

  // Remove spaces and dashes
  const cleaned = phoneNumber.replace(/[\s-]/g, '');

  // Valid AU mobile: starts with 04, followed by 8 digits (total 10 digits)
  // Format: 04XX XXX XXX
  const auMobileRegex = /^04[0-9]{8}$/;

  return auMobileRegex.test(cleaned);
};
